module.exports = __webpack_public_path__ + "static/media/01.fa282bcb.png";